type MobiusConfig = {
  [program: string]: {
    [school: string]: {
      apiKey: string;
      domain: string;
    };
  };
};

export const mobiusConfig: MobiusConfig = {
  ucb: {
  },
};
